/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FeeDTO,
  GetAllProductPropertiesParams,
  PageProductPropertiesDTO,
  ProductPropertiesDTO,
  UpdateProductOnlineStatusParams,
  UpdateProductStatusParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getProductProperties = (
    glNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductPropertiesDTO>(
      {url: `/api/product-properties/${glNo}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetProductPropertiesInfiniteQueryKey = (glNo?: string,) => {
    return [
    'infinite', `/api/product-properties/${glNo}`
    ] as const;
    }

export const getGetProductPropertiesQueryKey = (glNo?: string,) => {
    return [
    `/api/product-properties/${glNo}`
    ] as const;
    }

    
export const getGetProductPropertiesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProductProperties>>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductPropertiesInfiniteQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductProperties>>> = ({ signal }) => getProductProperties(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductPropertiesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProductProperties>>>
export type GetProductPropertiesInfiniteQueryError = unknown


export function useGetProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductProperties>>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductProperties>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductProperties>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductProperties>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductPropertiesInfiniteQueryOptions(glNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProductPropertiesQueryOptions = <TData = Awaited<ReturnType<typeof getProductProperties>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductPropertiesQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductProperties>>> = ({ signal }) => getProductProperties(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductPropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof getProductProperties>>>
export type GetProductPropertiesQueryError = unknown


export function useGetProductProperties<TData = Awaited<ReturnType<typeof getProductProperties>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductProperties<TData = Awaited<ReturnType<typeof getProductProperties>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductProperties<TData = Awaited<ReturnType<typeof getProductProperties>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProductProperties<TData = Awaited<ReturnType<typeof getProductProperties>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductPropertiesQueryOptions(glNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateProductProperties = (
    glNo: string,
    productPropertiesDTO: ProductPropertiesDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ProductPropertiesDTO>(
      {url: `/api/product-properties/${glNo}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productPropertiesDTO
    },
      options);
    }
  


export const getUpdateProductPropertiesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductProperties>>, TError,{glNo: string;data: ProductPropertiesDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductProperties>>, TError,{glNo: string;data: ProductPropertiesDTO}, TContext> => {

const mutationKey = ['updateProductProperties'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductProperties>>, {glNo: string;data: ProductPropertiesDTO}> = (props) => {
          const {glNo,data} = props ?? {};

          return  updateProductProperties(glNo,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductPropertiesMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductProperties>>>
    export type UpdateProductPropertiesMutationBody = ProductPropertiesDTO
    export type UpdateProductPropertiesMutationError = unknown

    export const useUpdateProductProperties = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductProperties>>, TError,{glNo: string;data: ProductPropertiesDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductProperties>>,
        TError,
        {glNo: string;data: ProductPropertiesDTO},
        TContext
      > => {

      const mutationOptions = getUpdateProductPropertiesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAllProductProperties = (
    params: GetAllProductPropertiesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageProductPropertiesDTO>(
      {url: `/api/product-properties`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAllProductPropertiesInfiniteQueryKey = (params?: GetAllProductPropertiesParams,) => {
    return [
    'infinite', `/api/product-properties`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetAllProductPropertiesQueryKey = (params?: GetAllProductPropertiesParams,) => {
    return [
    `/api/product-properties`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllProductPropertiesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllProductProperties>>>, TError = unknown>(params: GetAllProductPropertiesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllProductPropertiesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProductProperties>>> = ({ signal }) => getAllProductProperties(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllProductPropertiesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllProductProperties>>>
export type GetAllProductPropertiesInfiniteQueryError = unknown


export function useGetAllProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProductProperties>>>, TError = unknown>(
 params: GetAllProductPropertiesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getAllProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProductProperties>>>, TError = unknown>(
 params: GetAllProductPropertiesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getAllProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProductProperties>>>, TError = unknown>(
 params: GetAllProductPropertiesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProductProperties>>>, TError = unknown>(
 params: GetAllProductPropertiesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllProductPropertiesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllProductPropertiesQueryOptions = <TData = Awaited<ReturnType<typeof getAllProductProperties>>, TError = unknown>(params: GetAllProductPropertiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllProductPropertiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProductProperties>>> = ({ signal }) => getAllProductProperties(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllProductPropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllProductProperties>>>
export type GetAllProductPropertiesQueryError = unknown


export function useGetAllProductProperties<TData = Awaited<ReturnType<typeof getAllProductProperties>>, TError = unknown>(
 params: GetAllProductPropertiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getAllProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProductProperties<TData = Awaited<ReturnType<typeof getAllProductProperties>>, TError = unknown>(
 params: GetAllProductPropertiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getAllProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProductProperties<TData = Awaited<ReturnType<typeof getAllProductProperties>>, TError = unknown>(
 params: GetAllProductPropertiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllProductProperties<TData = Awaited<ReturnType<typeof getAllProductProperties>>, TError = unknown>(
 params: GetAllProductPropertiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllProductPropertiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createProductProperties = (
    productPropertiesDTO: ProductPropertiesDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductPropertiesDTO>(
      {url: `/api/product-properties`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productPropertiesDTO, signal
    },
      options);
    }
  


export const getCreateProductPropertiesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductProperties>>, TError,{data: ProductPropertiesDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductProperties>>, TError,{data: ProductPropertiesDTO}, TContext> => {

const mutationKey = ['createProductProperties'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductProperties>>, {data: ProductPropertiesDTO}> = (props) => {
          const {data} = props ?? {};

          return  createProductProperties(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProductPropertiesMutationResult = NonNullable<Awaited<ReturnType<typeof createProductProperties>>>
    export type CreateProductPropertiesMutationBody = ProductPropertiesDTO
    export type CreateProductPropertiesMutationError = unknown

    export const useCreateProductProperties = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductProperties>>, TError,{data: ProductPropertiesDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProductProperties>>,
        TError,
        {data: ProductPropertiesDTO},
        TContext
      > => {

      const mutationOptions = getCreateProductPropertiesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateProductStatus = (
    glNo: string,
    params: UpdateProductStatusParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ProductPropertiesDTO>(
      {url: `/api/product-properties/${glNo}/status`, method: 'PATCH',
        params
    },
      options);
    }
  


export const getUpdateProductStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductStatus>>, TError,{glNo: string;params: UpdateProductStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductStatus>>, TError,{glNo: string;params: UpdateProductStatusParams}, TContext> => {

const mutationKey = ['updateProductStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductStatus>>, {glNo: string;params: UpdateProductStatusParams}> = (props) => {
          const {glNo,params} = props ?? {};

          return  updateProductStatus(glNo,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductStatus>>>
    
    export type UpdateProductStatusMutationError = unknown

    export const useUpdateProductStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductStatus>>, TError,{glNo: string;params: UpdateProductStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductStatus>>,
        TError,
        {glNo: string;params: UpdateProductStatusParams},
        TContext
      > => {

      const mutationOptions = getUpdateProductStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateProductOnlineStatus = (
    glNo: string,
    params: UpdateProductOnlineStatusParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ProductPropertiesDTO>(
      {url: `/api/product-properties/${glNo}/online`, method: 'PATCH',
        params
    },
      options);
    }
  


export const getUpdateProductOnlineStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductOnlineStatus>>, TError,{glNo: string;params: UpdateProductOnlineStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductOnlineStatus>>, TError,{glNo: string;params: UpdateProductOnlineStatusParams}, TContext> => {

const mutationKey = ['updateProductOnlineStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductOnlineStatus>>, {glNo: string;params: UpdateProductOnlineStatusParams}> = (props) => {
          const {glNo,params} = props ?? {};

          return  updateProductOnlineStatus(glNo,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductOnlineStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductOnlineStatus>>>
    
    export type UpdateProductOnlineStatusMutationError = unknown

    export const useUpdateProductOnlineStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductOnlineStatus>>, TError,{glNo: string;params: UpdateProductOnlineStatusParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductOnlineStatus>>,
        TError,
        {glNo: string;params: UpdateProductOnlineStatusParams},
        TContext
      > => {

      const mutationOptions = getUpdateProductOnlineStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductFees = (
    glNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FeeDTO[]>(
      {url: `/api/product-properties/${glNo}/fees`, method: 'GET', signal
    },
      options);
    }
  



export const getGetProductFeesInfiniteQueryKey = (glNo?: string,) => {
    return [
    'infinite', `/api/product-properties/${glNo}/fees`
    ] as const;
    }

export const getGetProductFeesQueryKey = (glNo?: string,) => {
    return [
    `/api/product-properties/${glNo}/fees`
    ] as const;
    }

    
export const getGetProductFeesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProductFees>>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductFeesInfiniteQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductFees>>> = ({ signal }) => getProductFees(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductFeesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProductFees>>>
export type GetProductFeesInfiniteQueryError = unknown


export function useGetProductFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductFees>>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductFees>>,
          TError,
          Awaited<ReturnType<typeof getProductFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductFees>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductFees>>,
          TError,
          Awaited<ReturnType<typeof getProductFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductFees>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProductFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductFees>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductFeesInfiniteQueryOptions(glNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProductFeesQueryOptions = <TData = Awaited<ReturnType<typeof getProductFees>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductFeesQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductFees>>> = ({ signal }) => getProductFees(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductFeesQueryResult = NonNullable<Awaited<ReturnType<typeof getProductFees>>>
export type GetProductFeesQueryError = unknown


export function useGetProductFees<TData = Awaited<ReturnType<typeof getProductFees>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductFees>>,
          TError,
          Awaited<ReturnType<typeof getProductFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductFees<TData = Awaited<ReturnType<typeof getProductFees>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductFees>>,
          TError,
          Awaited<ReturnType<typeof getProductFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductFees<TData = Awaited<ReturnType<typeof getProductFees>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProductFees<TData = Awaited<ReturnType<typeof getProductFees>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductFeesQueryOptions(glNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getProductPropertiesByCode = (
    productCode: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductPropertiesDTO>(
      {url: `/api/product-properties/code/${productCode}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetProductPropertiesByCodeInfiniteQueryKey = (productCode?: string,) => {
    return [
    'infinite', `/api/product-properties/code/${productCode}`
    ] as const;
    }

export const getGetProductPropertiesByCodeQueryKey = (productCode?: string,) => {
    return [
    `/api/product-properties/code/${productCode}`
    ] as const;
    }

    
export const getGetProductPropertiesByCodeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProductPropertiesByCode>>>, TError = unknown>(productCode: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductPropertiesByCodeInfiniteQueryKey(productCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductPropertiesByCode>>> = ({ signal }) => getProductPropertiesByCode(productCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productCode), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductPropertiesByCodeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProductPropertiesByCode>>>
export type GetProductPropertiesByCodeInfiniteQueryError = unknown


export function useGetProductPropertiesByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductPropertiesByCode>>>, TError = unknown>(
 productCode: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPropertiesByCode>>,
          TError,
          Awaited<ReturnType<typeof getProductPropertiesByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductPropertiesByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductPropertiesByCode>>>, TError = unknown>(
 productCode: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPropertiesByCode>>,
          TError,
          Awaited<ReturnType<typeof getProductPropertiesByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductPropertiesByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductPropertiesByCode>>>, TError = unknown>(
 productCode: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProductPropertiesByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductPropertiesByCode>>>, TError = unknown>(
 productCode: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductPropertiesByCodeInfiniteQueryOptions(productCode,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProductPropertiesByCodeQueryOptions = <TData = Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError = unknown>(productCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductPropertiesByCodeQueryKey(productCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductPropertiesByCode>>> = ({ signal }) => getProductPropertiesByCode(productCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductPropertiesByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getProductPropertiesByCode>>>
export type GetProductPropertiesByCodeQueryError = unknown


export function useGetProductPropertiesByCode<TData = Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError = unknown>(
 productCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPropertiesByCode>>,
          TError,
          Awaited<ReturnType<typeof getProductPropertiesByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductPropertiesByCode<TData = Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError = unknown>(
 productCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPropertiesByCode>>,
          TError,
          Awaited<ReturnType<typeof getProductPropertiesByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductPropertiesByCode<TData = Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError = unknown>(
 productCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProductPropertiesByCode<TData = Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError = unknown>(
 productCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPropertiesByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductPropertiesByCodeQueryOptions(productCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllActiveProductProperties = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductPropertiesDTO[]>(
      {url: `/api/product-properties/active`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllActiveProductPropertiesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/product-properties/active`
    ] as const;
    }

export const getGetAllActiveProductPropertiesQueryKey = () => {
    return [
    `/api/product-properties/active`
    ] as const;
    }

    
export const getGetAllActiveProductPropertiesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveProductProperties>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllActiveProductPropertiesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllActiveProductProperties>>> = ({ signal }) => getAllActiveProductProperties(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllActiveProductPropertiesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllActiveProductProperties>>>
export type GetAllActiveProductPropertiesInfiniteQueryError = unknown


export function useGetAllActiveProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveProductProperties>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveProductProperties>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveProductProperties>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllActiveProductPropertiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveProductProperties>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllActiveProductPropertiesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllActiveProductPropertiesQueryOptions = <TData = Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllActiveProductPropertiesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllActiveProductProperties>>> = ({ signal }) => getAllActiveProductProperties(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllActiveProductPropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllActiveProductProperties>>>
export type GetAllActiveProductPropertiesQueryError = unknown


export function useGetAllActiveProductProperties<TData = Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveProductProperties<TData = Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveProductProperties>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveProductProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveProductProperties<TData = Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllActiveProductProperties<TData = Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveProductProperties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllActiveProductPropertiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




